var Material = (function () {
    function Material(gl_context_, gltf_data_, material_loader_) {
        this.gl_context_ = gl_context_;
        this.gltf_data_ = gltf_data_;
        this.material_loader_ = material_loader_;
    }
    ;
    Material.prototype.setTextures = function (material_index) {
        var data = this.gltf_data_.materials[material_index];
        if (data && data.pbrMetallicRoughness) {
            this.base_color_factor = data.pbrMetallicRoughness.baseColorFactor || [1, 1, 1, 1];
            if (data.pbrMetallicRoughness.baseColorTexture) {
                var texture_index = data.pbrMetallicRoughness.baseColorTexture.index;
                this.base_color_texture = this.material_loader_.getTexture(texture_index);
                this.base_color_sampler = this.material_loader_.getSampler(texture_index);
            }
            this.metallic_factor = data.pbrMetallicRoughness.metallicFactor || 1;
            this.roughness_factor = data.pbrMetallicRoughness.roughnessFactor || 1;
            if (data.pbrMetallicRoughness.metallicRoughnessTexture) {
                var texture_index = data.pbrMetallicRoughness.metallicRoughnessTexture.index;
                this.metallic_roughness_texture = this.material_loader_.getTexture(texture_index);
                this.metallic_roughness_sampler = this.material_loader_.getSampler(texture_index);
            }
        }
        else {
            this.base_color_factor = [1, 1, 1, 1];
            this.metallic_factor = 1;
            this.roughness_factor = 1;
        }
    };
    ;
    Material.prototype.setMaterialUniforms = function (program) {
        this.gl_context_.uniform4fv(program.getUniform("u_base_color_factor"), this.base_color_factor);
        if (this.base_color_texture) {
            this.gl_context_.activeTexture(this.gl_context_.TEXTURE0);
            this.base_color_texture.bindTexture();
            this.base_color_sampler.bindSampler(0);
            this.gl_context_.uniform1i(program.getUniform("u_base_color_texture"), 0);
        }
        this.gl_context_.uniform2fv(program.getUniform("u_metallic_roughness_factors"), [this.metallic_factor, this.roughness_factor]);
        if (this.metallic_roughness_texture) {
            this.gl_context_.activeTexture(this.gl_context_.TEXTURE1);
            this.metallic_roughness_texture.bindTexture();
            this.metallic_roughness_sampler.bindSampler(1);
            this.gl_context_.uniform1i(program.getUniform("u_metal_rough_texture"), 1);
        }
    };
    ;
    return Material;
}());
export { Material };
;
//# sourceMappingURL=material.js.map